import { Utils } from 'versafleet-core';

const { openInNewWindow } = Utils.RequestHelper;

class TaskHelper {
  /**
   * Print by Task ID
   *
   * @param {number} id Task ID
   */
  static print(id) {
    openInNewWindow(`/tasks/${id}/print`);
  }

  /**
   * Print (Task/Item) Label by Task ID
   *
   * @param {number} id Task ID
   */
  static printTaskLabel(id) {
    openInNewWindow(`/tasks/${id}/task_label`);
  }
}

export default TaskHelper;
